import { useBapApi } from "@/api/useBapApi";
import { captureError } from "@/helpers/captureError";

export const fetchRanks = async (tokens, type) => {
  let page = 1;
  let perPage = 100;
  let items = tokens.slice(0, perPage);
  let arr = [];
  while (items.length) {
    try {
      const tokensData = await useBapApi().exec({
        url: "/collection/list",
        params: {
          type: type,
          id: items.map((token) => token.id),
        },
      });
      arr = arr.concat(tokensData?.result?.result || []);
    } catch (err) {
      captureError(err);
    }
    page++;
    items = tokens.slice((page - 1) * perPage, page * perPage);
  }
  return arr.reduce((items, item) => {
    return { ...items, [item.id]: item };
  }, {});
};
